export default "__VITE_ASSET___ZaT2lgz__"